export const NATIVE_TOKEN = {
    name: "Zond",
    symbol: "QRL",
    decimals: 18,
};
